import { toTitleCase } from "../../../../Utils/stringUtls";

const NightlyFilesOverview = ({ data }) => {
  const {
    ov_nf_comp_cert,
    ov_nf_cut_off_time,
    ov_nf_pci_compliant,
    ov_nf_ssrp_for_manager,
  } = data["6_8"];
  if (!ov_nf_ssrp_for_manager?.length) return null;
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">Nightly Files (SSRP)</div>
          <div className="overview-help-text-for-heading font-bold">
            Would program manager also require SSRP nightly files form i2c Inc?
          </div>
          <div className="overview-val-text">
            {toTitleCase(ov_nf_ssrp_for_manager)}
          </div>
        </div>

        <div i2c-grid="12">
          <div className="overview-help-text font-bold">
            Preferred Cut Off Time
          </div>
          <div className="overview-val-text">{ov_nf_cut_off_time}</div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Are you PCI Compliant?
          </div>
          <div className="overview-val-text">
            {toTitleCase(ov_nf_pci_compliant)}
          </div>
        </div>
      </div>
    </div>
  );
};
export default NightlyFilesOverview;
